import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const searchIPDetails = createAsyncThunk('searchIPDetails/searchIPDetails', async (data) => {
    try {
        const res = await axios({
            method: 'post',
            url: process.env.REACT_APP_API_URL + `search_ip_details`,
            data: {
                fromdate: data.from_date,
                todate: data.to_date,
                link_id: data.link_id,
                type: data.type,
                report_type: data.report_type,
                report_id: data.report_id,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        })
        return res
    } catch (error) {
        return error.response || { status: 500, data: { message: 'Network error or timeout' } }
    }
})
